export const UI_STATUS = Object.freeze({
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  API_PROCESSING: 'API Processing',
});

/**
 * Kebab-cased status used in `data-test` values and badge class names.
 *
 * Mirrors the status branches of templates/file_explorer.html, where
 * 'API Processing' shares the in-progress badge, so a row rendered by the
 * browser is indistinguishable from a server-rendered one.
 */
export const STATUS_TEST_ID = Object.freeze({
  [UI_STATUS.COMPLETED]: 'completed',
  [UI_STATUS.FAILED]: 'failed',
  [UI_STATUS.NOT_STARTED]: 'not-started',
  [UI_STATUS.IN_PROGRESS]: 'in-progress',
  [UI_STATUS.API_PROCESSING]: 'in-progress',
});

export const TERMINAL_STATUSES = Object.freeze([UI_STATUS.COMPLETED, UI_STATUS.NOT_STARTED]);
